import { writable, derived } from "svelte/store";
import marked from "marked";
export const markdownText = writable("");
export const htmlOutput = derived(markdownText, ($markdownText) => ($markdownText ? marked($markdownText) : ""));
